<template>
  <div>
    <div class="title">
      {{ title }}
    </div>
    <div id="body">
      <div>
        <div v-for="it in deqCheckArr">
          <div class="bodyTitle" v-html="it.name"></div>
          <template v-for="its in it.center">
            <div class="bodyTitleSmall" v-html="its.title"></div>
            <div class="bodyHightWord" v-if="its.listTitle">
              <div v-for="val in its.listTitle">
                <div class="bodyHightWordCen" v-html="val.name"></div>
              </div>
              <span class="clear"></span>
            </div>
            <div class="bodyBor" v-if="its.list.length < 6">
              <div
                class="bodyBorder"
                v-for="val in its.list"
                @click="deqCheck(it, its, val)"
                :class="{ addBodyBorColor: val.check === 1 }"
                v-html="val.name"
              ></div>
            </div>
            <div class="bodyHightBor" v-else>
              <div
                class="bodyHightBorBorder"
                v-for="val in its.list"
                @click="deqCheck(it, its, val)"
                :class="{ addBodyBorColor: val.check === 1 }"
              >
                {{ val.name }}
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "./index.css";

export default {
  name: "DEQ",
  props: ["propsChild"],
  data() {
    return {
      title: "DEQ5",
      deqCheckArr: [
        {
          id: 0,
          name: '1. Questions about <span class="bodyTitleBold">EYE DISCOMFORT:</span>',
          center: [
            {
              id: 0,
              title:
                'a. During a typical day in the past month, <span class="bodyTitleSmallBold">how often</span> did your eyes feel discomfort?',
              list: [
                {
                  id: 0,
                  name: "Never",
                  check: "0",
                  val: "0"
                },
                {
                  id: 1,
                  name: "Rarely",
                  check: "0",
                  val: "1"
                },
                {
                  id: 2,
                  name: "Sometimes",
                  check: "0",
                  val: "2"
                },
                {
                  id: 3,
                  name: "Frequently",
                  check: "0",
                  val: "3"
                },
                {
                  id: 4,
                  name: "Constantly",
                  check: "0",
                  val: "4"
                }
              ]
            },
            {
              id: 1,
              title:
                'b. When your eyes felt discomfort, <span class="bodyTitleSmallBold">how intense was this feeling of discomfort</span> at the end of the day, within two hours of going to bed?',
              listTitle: [
                {
                  name: 'Never <div class="bodyHightWordCenBold">have it</div>'
                },
                {
                  name: 'Not at All <div class="bodyHightWordCenBold">Intense</div>'
                },
                {
                  name: 'Very <div class="bodyHightWordCenBold">Intense</div>'
                }
              ],
              list: [
                {
                  id: 0,
                  name: "0",
                  check: "0",
                  val: "0"
                },
                {
                  id: 1,
                  name: "1",
                  check: "0",
                  val: "1"
                },
                {
                  id: 2,
                  name: "2",
                  check: "0",
                  val: "2"
                },
                {
                  id: 3,
                  name: "3",
                  check: "0",
                  val: "3"
                },
                {
                  id: 4,
                  name: "4",
                  check: "0",
                  val: "4"
                },
                {
                  id: 5,
                  name: "5",
                  check: "0",
                  val: "5"
                }
              ]
            }
          ]
        },
        {
          id: 1,
          name: '2. Questions about <span class="bodyTitleBold">EYE DRYNESS:</div>',
          center: [
            {
              id: 0,
              title:
                'a. During a typical day in the past month, <span class="bodyTitleSmallBold">how often</span> did your eyes feel dry?',
              list: [
                {
                  id: 0,
                  name: "Never",
                  check: "0",
                  val: "0"
                },
                {
                  id: 1,
                  name: "Rarely",
                  check: "0",
                  val: "1"
                },
                {
                  id: 2,
                  name: "Sometimes",
                  check: "0",
                  val: "2"
                },
                {
                  id: 3,
                  name: "Frequently",
                  check: "0",
                  val: "3"
                },
                {
                  id: 4,
                  name: "Constantly",
                  check: "0",
                  val: "4"
                }
              ]
            },
            {
              id: 1,
              title:
                'b. When your eyes felt dry, <span class="bodyTitleSmallBold">how intense was this feeling of dryness</span> at the end of the day, within two hours of going to bed?',
              listTitle: [
                {
                  name: 'Never <div class="bodyHightWordCenBold">have it</div>'
                },
                {
                  name: 'Not at All <div class="bodyHightWordCenBold">Intense</div>'
                },
                {
                  name: 'Very <div class="bodyHightWordCenBold">Intense</div>'
                }
              ],
              list: [
                {
                  id: 0,
                  name: "0",
                  check: "0",
                  val: "0"
                },
                {
                  id: 1,
                  name: "1",
                  check: "0",
                  val: "1"
                },
                {
                  id: 2,
                  name: "2",
                  check: "0",
                  val: "2"
                },
                {
                  id: 3,
                  name: "3",
                  check: "0",
                  val: "3"
                },
                {
                  id: 4,
                  name: "4",
                  check: "0",
                  val: "4"
                },
                {
                  id: 5,
                  name: "5",
                  check: "0",
                  val: "5"
                }
              ]
            }
          ]
        },
        {
          id: 2,
          name: '3. Questions about<span class="bodyTitleBold"> WATERY EYES:</span>',
          center: [
            {
              id: 0,
              title:
                'During a typical day in the past month, <span class="bodyTitleSmallBold">how often</span>  did your eyes look or feel excessively watery?',
              list: [
                {
                  id: 0,
                  name: "Never",
                  check: "0",
                  val: "0"
                },
                {
                  id: 1,
                  name: "Rarely",
                  check: "0",
                  val: "1"
                },
                {
                  id: 2,
                  name: "Sometimes",
                  check: "0",
                  val: "2"
                },
                {
                  id: 3,
                  name: "Frequently",
                  check: "0",
                  val: "3"
                },
                {
                  id: 4,
                  name: "Constantly",
                  check: "0",
                  val: "4"
                }
              ]
            }
          ]
        }
      ],
      noCheckAll: [],
      deqArr: []
    };
  },
  methods: {
    deqCheck(it, its, val) {
      for (let i = 0; i < this.deqCheckArr[it.id].center[its.id].list.length; i++) {
        this.deqCheckArr[it.id].center[its.id].list[i].check = "0";
      }
      this.deqCheckArr[it.id].center[its.id].list[val.id].check = 1;
      this.emitFun();
    },
    emitFun() {
      this.deqArr = [];
      this.noCheckAll = [];
      for (let i = 0; i < this.deqCheckArr.length; i++) {
        for (let j = 0; j < this.deqCheckArr[i].center.length; j++) {
          for (let z = 0; z < this.deqCheckArr[i].center[j].list.length; z++) {
            if (this.deqCheckArr[i].center[j].list[z].check === 1) {
              this.deqArr.push({
                type: "EN",
                Pid: this.deqCheckArr[i].id,
                Pid2: this.deqCheckArr[i].center[j].id,
                id: this.deqCheckArr[i].center[j].list[z].id,
                val: this.deqCheckArr[i].center[j].list[z].val
              });
            }
          }
        }
      }

      // 存储未选中
      for (let i = 0; i < this.deqCheckArr.length; i++) {
        for (let j = 0; j < this.deqCheckArr[i].center.length; j++) {
          let isExist = false;
          for (let a = 0; a < this.deqArr.length; a++) {
            if (this.deqCheckArr[i].id === this.deqArr[a].Pid) {
              if (this.deqCheckArr[i].center[j].id === this.deqArr[a].Pid2) {
                isExist = true;
                break;
              }
            }
          }
          if (!isExist) {
            this.noCheckAll.push(this.deqCheckArr[i]);
          }
        }
      }
      this.$emit("emitMcFun", this.deqArr, this.noCheckAll);
    },
    initShow() {
      // // 模拟值
      if (this.propsChild) {
        let arrAy = this.propsChild;
        for (let i = 0; i < this.deqCheckArr.length; i++) {
          for (let j = 0; j < arrAy.length; j++) {
            if (this.deqCheckArr[i].id === arrAy[j].Pid) {
              this.deqCheckArr[i].center[arrAy[j].Pid2].list[arrAy[j].id].check = 1;
            }
          }
        }
      }
    }
  },
  mounted() {
    this.initShow();
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/dryeye/components/questions/EN/DEQ.vue